import React from "react"
import Join from "assets/join_cafe.png";
const JoinCafe = ({ }) => {
    return (<>
        <div className="bg-white overflow-hidden">
            <div className="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">


                <div data-aos="fade-left" className="mt-8 lg:flex lg:justify-between lg:items-center">

                    <div className=" lg:mt-0">
                        <div>
                            <h3 className="mt-2 text-4xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                The pawer of commeownity!
                            </h3>
                        </div>
                        <div className="mt-8 text-base max-w-prose mx-auto lg:max-w-none">
                            <p className="text-lg text-gray-500">
                                The Chibi Cat Cafe is always open to everyone. After all, the Cafe runs on your Love and a lot of little chibi paws!
                            </p>
                            <p className="text-lg text-gray-500">
                                The Cafe is primarily situated in a discord server where all the Chibi Cat lovers connect and enjoy some quality time…
                            </p>
                            <br />
                            <p className="text-lg text-gray-500">
                                Let’s build a Chibi Cat Commeownity!
                            </p>
                            <br />
                            <p className="text-lg text-gray-500">
                                Don’t forget to follow us on Twitter for all the recent updates and awesome giveaways
                            </p>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </>);
}
export default JoinCafe